export const COURSES_NOT_APPROVED_YET_WITH_USER_REQ =
  "courseNotApprovedYetWithUserReq";
export const COURSES_NOT_APPROVED_YET_WITH_USER_SUCCESS =
  "courseNotApprovedYetWithUserSuccess";
export const COURSES_NOT_APPROVED_YET_WITH_USER_FAIL =
  "courseNotApprovedYetWithUserFail";
